<template>
	<JBox>
		<JBox>
			<JSelect v-model="selectedTemplateQuery" :options="templateQueries" @input="$emit('input', $event)" placeholder="Custom" />
		</JBox>
		<JBox class="s-mt-1">
			<JButton variant="default-light-xs" @click="showAdvanced = !showAdvanced">
				{{ showAdvanced ? this.$t("core.hideAdvanced") : this.$t("core.showAdvanced") }}
			</JButton>
		</JBox>
		<Transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut fastest">
			<JBox class="s-mt-1" v-if="showAdvanced">
				<CCodeEditor class="s-w-full" :value="value" @input="$emit('input', $event)" language="graphql" />
			</JBox>
		</Transition>
	</JBox>
</template>

<script>
import queryList from "./queries/"

export default {
	props: {
		value: {
			type: String,
			default: () => ""
		}
	},

	data() {
		return {
			selectedTemplateQuery: null,
			showAdvanced: false
		}
	},

	computed: {
		templateQueries() {
			return queryList?.map(item => ({
				...item,
				name: item.name,
				value: item.query
			}))
		}
	},

	watch: {
		value: {
			handler(newValue) {
				// Getting graphql query string as newValue
				this.selectedTemplateQuery = newValue
			},
			immediate: true
		}
	}
}
</script>
